import {Component} from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {InsuranceData, IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {IntroInsurranceValidationPage} from "../intro-insurrance-validation/intro-insurrance-validation";
import {IntroDescriptionPage} from "../intro-description/intro-description";
import {LoginPage} from "../login/login";
import {InsuranceProvider} from "../../providers/insurance/insurance";
import {RegisterPage} from "../register/register";
import {WheelSelector} from "@ionic-native/wheel-selector";
import {IntroInsuranceConfirmationPage} from "../intro-insurance-confirmation/intro-insurance-confirmation";

/**
 * Generated class for the IntroChooseInsurranceCompanyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-choose-insurrance-company',
  templateUrl: 'intro-choose-insurrance-company.html',
})
export class IntroChooseInsurranceCompanyPage {
  loginPage: any = LoginPage;
  errorVisible: boolean = false;
  companies: any = [];
  freeCompanies: any = [];
  isNativeEnv: boolean = true;

  constructor(public navCtrl: NavController, public navParams: NavParams, public introWizard: IntroWizardServiceProvider, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider, public platform: Platform, public insurance: InsuranceProvider, public selector: WheelSelector) {
  }

  ionViewDidLoad() {
    if(!((window as any).cordova)) {
      this.isNativeEnv = false;
    }
    console.log('ionViewDidLoad IntroChooseInsurranceCompanyPage');

    this.companies = [];
    this.freeCompanies = [];
    this.insurance.getCompanies().then((data:any) => {
      this.companies = data;
      this.companies.sort((a,b) => {
        return a.position > b.position?1:-1;
      })
      for(var k in data) {
        if(data[k].free) {
          this.freeCompanies.push(data[k].name);
        }
      }
    })
  }

  showMoreInfoAboutChoosingCompany() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Registration Insurance Model Why I need provide title'),
      subTitle: this.contentTranslation.translateContent('Registration Insurance Model Why I need provide text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  isAokInsurer() {
    return (this.introWizard.insurer && this.freeCompanies.indexOf(this.introWizard.insurer)>-1);
  }

  chooseCompanyPopup() {

    let companiesSimple = this.companies.map((row) => {
      return {description: row.name, name: row.name, free: row.free, payoutAmount: row.payoutAmount}
    });;


    this.selector.show({
      title: this.contentTranslation.translateContent('Select company'),
      positiveButtonText: this.contentTranslation.translateContent('Wheel OK'),
      negativeButtonText: this.contentTranslation.translateContent('Wheel Cancel'),
      items: [
        companiesSimple
      ],
    }).then(
      result => {
        let company = companiesSimple[result[0].index];
        this.introWizard.insurer = company.name;
      },
      err => console.log('Error: ', err)
    );

  }

  nextStep() {
    if(!this.introWizard.insurer) {
      this.errorVisible = true;
      return ;
    }
    if (this.isAokInsurer()) {
      this.introWizard.freeOffer = true;
      this.introWizard.insurance = new InsuranceData();
      this.navCtrl.push(IntroInsuranceConfirmationPage)
    } else {
      this.introWizard.freeOffer = false;
      if(this.introWizard.insurance) {
        this.introWizard.insurance.aokId = '';
      }
      this.navCtrl.push(IntroInsurranceValidationPage)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intro-choose-insurrance-company/intro-choose-insurrance-company.ts